module.exports = __webpack_public_path__ + "img/r2.07e94c38.jpg";